import { Box, Typography } from '@mui/material'
import CustomOption2 from '../components/CustomOption2'
import CustomCheckbox from '../components/Inputs/CustomCheckbox'
const WorkingEnvironment = () => {
  return (
    <Box sx={{ padding: '20px 0px 40px 0px' }}>
      <Typography className="general-text-light" sx={{ mb: 6 }}>
        <span className="general-text">Task Name - </span>Working Environment
      </Typography>
      <Typography className="general-text">Hazardous Elements</Typography>
      <CustomCheckbox
        label="General atmosphere"
        name="General_atmosphere"
        component={
          <Box>
            <CustomOption2
              label="Contraction / Transmission of Virus (COVID) - "
              name="transmission_of_virus"
              warning={true}
              sliderDescription="Regular hand washing, particularly at meal and toilet breaks, social distancing of at least 1.5m from another person keeping 4sqm distance, wearing nitrile gloves at all times on site. Wearing of face mask / shield at times required by prevailing Victorian Health Department regulations, otherwise where clients / tasks require."
            />
          </Box>
        }
        conditional_heading="General atmosphere"
      />
      <CustomCheckbox
        label="External atmosphere"
        name="External_atmosphere"
        component={
          <Box>
            <CustomOption2
              label="Exposure to the sun - ultra violet rays - "
              name="Exposure_to_the_sun"
              warning={true}
              sliderDescription="Review of sun exposure hazards - use of protective equipment clothing e.g. Sun hat, safety glasses - UV rated, Sunscreen 30+ on exposure skin areas, remain hydrated and provide shade as required. Review scheduled working hours - determine if the scope of work can be performed outside the hotter parts of the day"
            />
          </Box>
        }
        conditional_heading="External atmosphere"
      />
      <CustomCheckbox
        label="Internal atmosphere"
        name="Internal_atmosphere"
        component={
          <Box>
            <CustomOption2
              label="Contaminated internal atmosphere -  "
              name="Contaminated_internal_atmosphere"
              warning={true}
              sliderDescription="Use of appropriate PPE respiratory protection where required. Ensure adequate ventilation for the scope of works."
            />
          </Box>
        }
        conditional_heading="Internal atmosphere"
      />
    </Box>
  )
}

export default WorkingEnvironment
